<!--P080、P081、P082、P083-->
<template>
  <div class="div_content">
    <div class="cs_margin_top_sm ui_hierarchy">
      <div class="cs_cursor_pointer ui_txt_hierarchy" @click="$router.push({name:'RoleManage'})">权限管理</div>
      <div class="ui_txt_hierarchy">&nbsp;>&nbsp;</div>
      <div class="cs_font_bold cs_cursor_pointer ui_txt_hierarchy">角色详情</div>
    </div>
    <!--基本信息-->
    <div class="cs_margin_top ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">基本信息</div>
    </div>
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">角色名称</div>
      <input v-model="name" class="cs_input cs_radius_lg edtxt_info_search" placeholder="请输入">
    </div>
    <!--权限信息-->
    <div class="cs_margin_top_xl ui_divider_title">
      <div class="divider_title_info"></div>
      <div class="title_info">权限信息</div>
    </div>
    <!--门店-->
    <div class="cs_margin_top div_search">
      <div class="cs_title_primary cs_text_default type_info_search">门店权限</div>
      <div class="cs_radius_lg txt_info_search width_80 ui_margin_left_44">{{shopNum}}</div>
      <button @click="btnShop" class="cs_btn cs_btn_sm ui_btn_common cs_margin_left_sm"
              type="button">编辑
      </button>
    </div>
    <!--配送中心-->
    <div class="cs_margin_top_sm div_search">
      <div class="cs_title_primary cs_text_default type_info_search">配送中心权限</div>
      <div class="cs_radius_lg txt_info_search width_80">{{dcNum}}</div>
      <button @click="btnDc" class="cs_btn cs_btn_sm ui_btn_common cs_margin_left_sm"
              type="button">编辑
      </button>
    </div>
    <!--中央厨房-->
    <div class="cs_margin_top_sm div_search">
      <div class="cs_title_primary cs_text_default type_info_search">中央厨房权限</div>
      <div class="cs_radius_lg txt_info_search width_80">{{kitchenNum}}</div>
      <button @click="btnKitchen" class="cs_btn cs_btn_sm ui_btn_common cs_margin_left_sm"
              type="button">编辑
      </button>
    </div>
    <div class="div_operation_table cs_align_center" style="margin-top:350px;">
      <button @click="btnCancel" class="cs_btn cs_btn_sm ui_btn_ghost_blue"
              type="button">取消
      </button>
      <button @click="btnSave" class="cs_btn cs_btn_sm ui_btn_blue ui_margin_left_88"
              type="button">确认
      </button>
    </div>
    <div class="div_bottom"></div>

    <!--门店弹窗，默认隐藏-->
    <div v-if="isDialogShopShow" class="ui_div_dialog">
      <div class="dialog_container cs_padding_top cs_padding_bottom_xl">
        <div class="ui_divider_title cs_margin_left">
          <div class="divider_title_info"></div>
          <div class="title_info">编辑门店权限</div>
          <div class="div_cbtn" style="margin-top: 2px;margin-left: 132px;">
            <span class="icon_cbtn" :class="{'on':selectAllShop}"></span>
            <input value="true" class="txt_cbtn" :checked='selectAllShop'  @click="checkAllShop" type="checkbox">全选
          </div>
        </div>
        <div class="cs_margin_top div_search" style="margin-left:20px;">
          <div v-for="(item,index) in shopList" class="div_cbtn" :title="item.title">
            <span class="icon_cbtn" :class="{'on':item.isChecked}"></span>
            <input :value="item.id" class="txt_cbtn" :checked='item.isChecked'  @click="checkShop(item)" type="checkbox">{{item.permissionName}}
          </div>
        </div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogShop">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmShopDialog">确定</button>
        </div>
      </div>
    </div>
    <!--配送中心弹窗，默认隐藏-->
    <div v-if="isDialogDcShow" class="ui_div_dialog">
      <div class="dialog_container cs_padding_top cs_padding_bottom_xl">
        <div class="ui_divider_title cs_margin_left">
          <div class="divider_title_info"></div>
          <div class="title_info">编辑配送中心权限</div>
          <div class="div_cbtn" style="margin-top: 2px;margin-left: 164px;">
            <span class="icon_cbtn" :class="{'on':selectAllDc}"></span>
            <input value="true" class="txt_cbtn" :checked='selectAllDc'  @click="checkAllDc" type="checkbox">全选
          </div>
        </div>
        <div class="cs_margin_top div_search" style="margin-left:20px;">
          <div v-for="(item,index) in dcList" class="div_cbtn" :title="item.title">
            <span class="icon_cbtn" :class="{'on':item.isChecked}"></span>
            <input :value="item.id" class="txt_cbtn" :checked='item.isChecked'  @click="checkDc(item)" type="checkbox">{{item.permissionName}}
          </div>
        </div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogDc">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmDcDialog">确定</button>
        </div>
      </div>
    </div>
    <!--中央厨房弹窗，默认隐藏-->
    <div v-if="isDialogKitchenShow" class="ui_div_dialog">
      <div class="dialog_container cs_padding_top cs_padding_bottom_xl">
        <div class="ui_divider_title cs_margin_left">
          <div class="divider_title_info"></div>
          <div class="title_info">编辑中央厨房权限</div>
          <div class="div_cbtn" style="margin-top: 2px;margin-left: 164px;">
            <span class="icon_cbtn" :class="{'on':selectAllKitchen}"></span>
            <input value="true" class="txt_cbtn" :checked='selectAllKitchen'  @click="checkAllKitchen" type="checkbox">全选
          </div>
        </div>
        <div class="cs_margin_top div_search" style="margin-left:20px;">
          <div v-for="(item,index) in kitchenList" class="div_cbtn" :title="item.title">
            <span class="icon_cbtn" :class="{'on':item.isChecked}"></span>
            <input :value="item.id" class="txt_cbtn" :checked='item.isChecked'  @click="checkKitchen(item)" type="checkbox">{{item.permissionName}}
          </div>
        </div>
        <!--确定取消按钮-->
        <div class="cs_margin_top_lg div_search cs_align_center">
          <button type="button" class="cs_btn ui_btn_ghost_blue" @click="closeDialogKitchen">取消</button>
          <button type="button" class="cs_btn ui_btn_blue ui_margin_left_88" @click="btnConfirmKitchenDialog">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import WebSelect from "../../components/web-select"
  import SearchSelect from "../../components/search-select"
  export default {
    name: "RoleDetail",
    components: {WebSelect,SearchSelect},
    data: function () {
      return {
        name: this.$route.query.name,
        shopNum: "",
        dcNum: "",
        kitchenNum:"",
        isDialogShopShow: false,
        shopList: [],
        shopSelectedList: [],
        selectAllShop:false,
        selectAllListShop:[],
        isDialogDcShow: false,
        dcList: [],
        dcSelectedList: [],
        selectAllDc:false,
        selectAllListDc:[],
        isDialogKitchenShow: false,
        kitchenList: [],
        kitchenSelectedList: [],
        selectAllKitchen:false,
        selectAllListKitchen:[],
      }
    },
    created: function () {
      this.showDetail();
    },
    mounted: function() {
    },
    methods: {
      showDetail(){
        this.$ajax.role.acquireRole.bind(this)(this.$route.query.id,(data) => {
          this.shopNum = data.data.SHOP;
          this.dcNum = data.data.DISTRIBUTION;
          this.kitchenNum = data.data.KITCHEN;
        }, (data) => {
        }, true)
      },
      btnSave(){
        if(this.isEmpty(this.name)){
          this.$toast("请输入角色名称");
          return;
        }
        this.$ajax.role.modify.bind(this)(this.$route.query.id,this.name,(data) => {
          this.$toast("保存成功");
          this.$router.replace({name:'RoleManage'});
        }, (data) => {
        }, true)
      },
      btnCancel(){
        this.$router.go(-1);
      },

      //门店
      btnShop(){
        this.$ajax.role.listModulePerms.bind(this)("SHOP", (data) => {
          let list = data.data;
          list.forEach((item) => {
            item.isChecked = false;
            item.title = item.permissionName.length>8?item.permissionName:"";
          });
          this.shopList = list;
          if(this.shopNum>0){
            this.showShopSelected();
          }else{
            this.isDialogShopShow = true;
          }
        }, (data) => {
        }, true);
      },
      showShopSelected(){
        this.$ajax.role.listRolePerms.bind(this)(this.$route.query.id,"SHOP", (data) => {
          let list = data.data;
          list.forEach((item) => {
            this.shopSelectedList.push(item.id);
          });
          this.shopList.forEach((item) => {
            item.isChecked = this.isInArray(this.shopSelectedList, item.id);
          });
          this.selectAllShop = this.shopList.length===this.shopSelectedList.length;
          this.isDialogShopShow = true;
        }, (data) => {
        }, true);
      },
      closeDialogShop(){
        this.shopList = [];
        this.shopSelectedList = [];
        this.isDialogShopShow = false;
        this.selectAllShop = false;
        this.selectAllListShop = [];
        this.showDetail();
      },
      btnConfirmShopDialog(){
        let shopIds= "";
        this.shopList.forEach((item) => {
          if(item.isChecked){
            shopIds += item.id + ",";
          }
        });
        this.$ajax.role.saveRolePerms.bind(this)(this.$route.query.id,"SHOP",shopIds, (data) => {
          this.closeDialogShop();
        }, (data) => {
        }, true);
      },
      //配送中心
      btnDc(){
        this.$ajax.role.listModulePerms.bind(this)("DISTRIBUTION", (data) => {
          let list = data.data;
          list.forEach((item) => {
            item.isChecked = false;
            item.title = item.permissionName.length>8?item.permissionName:"";
          });
          this.dcList = list;
          if(this.dcNum>0){
            this.showDcSelected();
          }else{
            this.isDialogDcShow = true;
          }
        }, (data) => {
        }, true);
      },
      showDcSelected(){
        this.$ajax.role.listRolePerms.bind(this)(this.$route.query.id,"DISTRIBUTION", (data) => {
          let list = data.data;
          list.forEach((item) => {
            this.dcSelectedList.push(item.id);
          });
          this.dcList.forEach((item) => {
            item.isChecked = this.isInArray(this.dcSelectedList, item.id);
          });
          this.selectAllDc = this.dcList.length===this.dcSelectedList.length;
          this.isDialogDcShow = true;
        }, (data) => {
        }, true);
      },
      closeDialogDc(){
        this.dcList = [];
        this.dcSelectedList = [];
        this.selectAllDc = false;
        this.selectAllListDc = [];
        this.isDialogDcShow = false;
        this.showDetail();
      },
      btnConfirmDcDialog(){
        let dcIds= "";
        this.dcList.forEach((item) => {
          if(item.isChecked){
            dcIds += item.id + ",";
          }
        });
        this.$ajax.role.saveRolePerms.bind(this)(this.$route.query.id,"DISTRIBUTION",dcIds, (data) => {
          this.closeDialogDc();
        }, (data) => {
        }, true);
      },
      //中央厨房
      btnKitchen(){
        this.$ajax.role.listModulePerms.bind(this)("KITCHEN", (data) => {
          let list = data.data;
          list.forEach((item) => {
            item.isChecked = false;
            item.title = item.permissionName.length>8?item.permissionName:"";
          });
          this.kitchenList = list;
          if(this.kitchenNum>0){
            this.showKitchenSelected();
          }else{
            this.isDialogKitchenShow = true;
          }
        }, (data) => {
        }, true);
      },
      showKitchenSelected(){
        this.$ajax.role.listRolePerms.bind(this)(this.$route.query.id,"KITCHEN", (data) => {
          let list = data.data;
          list.forEach((item) => {
            this.kitchenSelectedList.push(item.id);
          });
          this.kitchenList.forEach((item) => {
            item.isChecked = this.isInArray(this.kitchenSelectedList, item.id);
          });
          this.selectAllKitchen = this.kitchenList.length===this.kitchenSelectedList.length;
          this.isDialogKitchenShow = true;
        }, (data) => {
        }, true);
      },
      closeDialogKitchen(){
        this.kitchenList = [];
        this.kitchenSelectedList = [];
        this.isDialogKitchenShow = false;
        this.selectAllKitchen = false;
        this.selectAllListKitchen = [];
        this.showDetail();
      },
      btnConfirmKitchenDialog(){
        let kitchenIds= "";
        this.kitchenList.forEach((item) => {
          if(item.isChecked){
            kitchenIds += item.id + ",";
          }
        });
        this.$ajax.role.saveRolePerms.bind(this)(this.$route.query.id,"KITCHEN",kitchenIds, (data) => {
          this.closeDialogKitchen();
        }, (data) => {
        }, true);
      },

      checkShop(item) {
        let selected = item.isChecked;
        item.isChecked = !selected;
        let selectAll = true;
        this.shopList.forEach((item) => {
          selectAll = selectAll && item.isChecked;
        });
        this.selectAllShop = selectAll;
      },
      checkAllShop() {
        this.selectAllShop = !this.selectAllShop;
        if(this.selectAllShop){
          this.shopList.forEach((item) => {
            item.isChecked = true;
          });
        }else{
          this.shopList.forEach((item) => {
            item.isChecked = false;
          });
        }
      },
      checkDc(item) {
        let selected = item.isChecked;
        item.isChecked = !selected;
        let selectAll = true;
        this.dcList.forEach((item) => {
          selectAll = selectAll && item.isChecked;
        });
        this.selectAllDc = selectAll;
      },
      checkAllDc() {
        this.selectAllDc = !this.selectAllDc;
        if(this.selectAllDc){
          this.dcList.forEach((item) => {
            item.isChecked = true;
          });
        }else{
          this.dcList.forEach((item) => {
            item.isChecked = false;
          });
        }
      },
      checkKitchen(item) {
        let selected = item.isChecked;
        item.isChecked = !selected;
        let selectAll = true;
        this.kitchenList.forEach((item) => {
          selectAll = selectAll && item.isChecked;
        });
        this.selectAllKitchen = selectAll;
      },
      checkAllKitchen() {
        this.selectAllKitchen = !this.selectAllKitchen;
        if(this.selectAllKitchen){
          this.kitchenList.forEach((item) => {
            item.isChecked = true;
          });
        }else{
          this.kitchenList.forEach((item) => {
            item.isChecked = false;
          });
        }
      },
      isInArray(arr,value){
        return arr.some((item)=>{
          if(item===value){
            return true;
          }
        })
      }
    },
  }
</script>

<style scoped>
  .width_80{width: 80px;}
  .dialog_container{
    position:absolute;
    width: 536px;
    max-height: 100%;
    overflow-y: auto;
    top: 50%;
    left: 50%;
    margin-left: -268px;
    transform: translateY(-50%);
    background:#FFFFFF;
    box-shadow:0 0 4px 0 rgba(0,0,0,0.1);
    border-radius:8px;
    box-sizing: border-box;
    overflow-x: hidden;
  }

  .div_cbtn{
    position: relative;
    display: inline-block;
    margin-top: 8px;
    margin-left: 5px;
    width: 155px;
    height: 22px;
    line-height: 22px;
    font-size: 14px;
    color: #333333;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .txt_cbtn {
    display: inline-block;
    position: absolute;
    opacity: 0;
    width: 22px;
    height: 22px;
    cursor: pointer;
    left: 0;
    outline: none;
    -webkit-appearance: none;
  }
  .icon_cbtn {
    display: inline-block;
    vertical-align: top;
    width: 22px;
    height: 22px;
    cursor: pointer;
    background: url(../../assets/image/icon_cbtn.png) no-repeat center;
    background-size: 16px 16px;
  }
  .on {
    background: url(../../assets/image/icon_cbtn_checked.png) no-repeat center;
    background-size: 16px 16px;
  }
</style>



// WEBPACK FOOTER //
// src/page/role/RoleDetail.vue